import Modal from 'react-bootstrap/Modal';

const AlertModal = ({ show, handleOnClick, headerTitle, messageBody, buttonText }) => {
    return (
        <Modal show={show} onHide={handleOnClick} centered>
            <Modal.Header closeButton style={{backgroundColor: '#1E70E0', color: 'white', borderBottom: 'none'}}>
                <Modal.Title className="fw-semibold">
                    {headerTitle}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-4">
                {messageBody}
            </Modal.Body>
            <Modal.Footer style={{borderTop: '1px solid var(--gray-200)'}}>
                <button className="btn btn-primary" onClick={handleOnClick}>
                    {buttonText}
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default AlertModal;

